import BaseService from "../../BaseService";
import { AxiosResponse } from "axios";
import LicenseResponse from "./LicenseResponse";
import ApiResponse from "../../ApiResponse";
import License from "../../../models/License";

export default class LicenseService extends BaseService {

    fetch(page: number = 1, search: string = ""): Promise<AxiosResponse<LicenseResponse>> {
        let uri: string = `/licenses?page=${page}`;

        if(search !== "") uri += `&q=${search}`;

        return this.axios.get(uri, this.getCancelTokenStructure());
    }

    store(formData: FormData): Promise<AxiosResponse<ApiResponse<License>>> {
        return this.axios.post(`/licenses`, formData);
    }

    show(id: string): Promise<AxiosResponse<ApiResponse<License>>> {
        return this.axios.get(`/licenses/${id}`, this.getCancelTokenStructure() );
    }

    transfer(id: string, transferUser: FormData): Promise<AxiosResponse<ApiResponse<License>>> {
        return this.axios.post(`/licenses/${id}/user-transfer`, transferUser);
    }

    update(id: string, formData: FormData): Promise<AxiosResponse<ApiResponse<License>>> {
        return this.axios.put(`/licenses/${id}`, formData);
    }

    recover(id: string): Promise<AxiosResponse<ApiResponse<License>>> {
        return this.axios.post(`/licenses/${id}/recover-transfer`);
    }
}